import { QueryClient } from '@tanstack/react-query';

import { FIVE_MINUTES, TEN_MINUTES } from '../hooks/queries/constants';
import { devError } from '../utils/log';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTES,
      gcTime: TEN_MINUTES,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
      onError: (error) => {
        devError('Mutation error:', error);
      },
    },
  },
});

export const bingoQueryKeys = {
  all: ['bingo'],
  upcomingEvents: (daysAhead: number = 30) => [...bingoQueryKeys.all, 'upcoming', daysAhead],
  historicalEvents: (lastNDays: number = 30) => [...bingoQueryKeys.all, 'historical', lastNDays],
  storePackages: () => [...bingoQueryKeys.all, 'store-packages'],
  currentEvent: () => [...bingoQueryKeys.all, 'current-event'],
  tokenPrice: (quantity: number) => [...bingoQueryKeys.all, 'token-price', quantity],
  featuredPrizes: () => [...bingoQueryKeys.all, 'featured-prizes'],
};

export const subscriptionQueryKeys = {
  all: ['subscription'],
  data: () => [...subscriptionQueryKeys.all, 'data'],
};
